import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { nutzungStarten } from './lib/nutzung'
import { serviceWorkerAnmelden } from './lib/pwa'
import { router } from './router'
import './styles/theme.css'

/** Installierbar aufs Telefon (Z-16) – nur im gebauten Stand, siehe `lib/pwa.ts`. */
serviceWorkerAnmelden()

/** Was wie oft benutzt wird – ohne Personenbezug (E-410). */
nutzungStarten(router)

/**
 * Leitplanke 1: keine Standardaktion zeigt einen Spinner. Deshalb wird nicht
 * automatisch nachgeladen – aktuell gehalten wird über WebSocket (siehe
 * AppShell), nicht durch Abfragen bei jedem Fensterwechsel.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Wurzelelement #root fehlt in index.html')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
